import script from "./Textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=e0e861e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0e861e8"]])

export default __exports__